module.exports = __webpack_public_path__ + "img/7a7b9.637358e9.svg";